import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import Header from './header';
import { useMediaQuery } from '@mui/material';
import backgroundImage from './layout-background.png';
const Layout = () => {
    const isSmallScreen = useMediaQuery('(max-width:1200px)');
    return (_jsx("div", { style: {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: "100svh"
        }, children: _jsxs("div", { style: {
                minHeight: '100%',
                width: isSmallScreen ? 'calc(100% - 20px)' : 'calc(100% - 180px)',
                overflow: 'hidden',
                justifyContent: 'center',
                margin: '0 auto'
            }, children: [_jsx(Header, {}), _jsx("main", { children: _jsx(Outlet, {}) })] }) }));
};
export default Layout;
